<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :title="$t('labels.createReceiptRecord')"
        :submit="handleCreatePaymentRecord"
        @close="close">
        <div>
            <hts-form-date
                v-model="formData.receiptDate"
                required
                :label="$t('labels.receiptDate')" />

            <hts-form-input
                v-model="formData.amout"
                required
                form="number"
                :label="$t('labels.amout')" />
        </div>
    </hts-drawer>
</template>

<script lang="ts" setup>
const visible = ref<boolean>(false)
const emits = defineEmits(['refreshTables'])
const tripId = ref('')
const invoiceId = ref('')

const open = (tId: string, invoiceData: any) => {
  tripId.value = tId
  invoiceId.value = invoiceData._id
  visible.value = true

  const amout = invoiceData.totalAmount - invoiceData.paidAmoutTotal
  formData.value.amout = amout
  formData.value.invoiceId = invoiceData._id

  const today = new Date()
  const day = String(today.getDate()).padStart(2, '0')
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const year = today.getFullYear()

  const formattedDate = `${year}-${month}-${day}`
  formData.value.receiptDate = formattedDate
}

const close = () => {
  visible.value = false
}

const formData = ref({
  invoiceId: '',
  receiptDate: '',
  amout: 0
})

const handleCreatePaymentRecord = async () => {
  const api = {
    url: '/trip/tripId/billing-and-costing/invoice/receipt-record',
    method: 'post'
  }

  const data: any = await $api(api, {
    uriParams: { tripId: tripId.value },
    body: formData.value
  })

  const resData = data?.data?.value

  if (resData && resData.success) {
    process.client && $toast().success($t('labels.addSuccess'))
    close()
    emits('refreshTables')
  }
}

defineExpose({
  open,
  close
})
</script>
